"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.viemConnector = void 0;
const viem_1 = require("viem");
const chains_1 = require("viem/chains");
const contracts_1 = require("../contracts");
const viemConnector = (args) => {
    const publicClient = (0, viem_1.createPublicClient)({
        chain: chains_1.optimismSepolia,
        transport: (0, viem_1.http)(args === null || args === void 0 ? void 0 : args.rpcUrl),
    });
    const isVerified = (fid) => __awaiter(void 0, void 0, void 0, function* () {
        return publicClient.readContract({
            address: contracts_1.addresses.verify,
            abi: contracts_1.abis.verify,
            functionName: "isVerified",
            args: [fid],
        });
    });
    return {
        isVerified,
    };
};
exports.viemConnector = viemConnector;
